import React from 'react';
import PropTypes from 'prop-types';
import { Button, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './private-inspections.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PrivateInspections = _ref => {
  var bookInspection = _ref.bookInspection,
    agentName = _ref.agentName,
    onBookHomepassInspectionClick = _ref.onBookHomepassInspectionClick,
    onContactAgentClick = _ref.onContactAgentClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _ref2 = bookInspection || {},
    provider = _ref2.provider,
    url = _ref2.url;
  var isHomepass = provider === 'HOMEPASS';
  var BookButton = url ? LinkButton : Button;
  var handleBookInspection = () => {
    if (provider) {
      sendEvent('book-inspection-click');
      if (isHomepass) {
        onBookHomepassInspectionClick();
      }
    } else {
      sendEvent('email-click');
      onContactAgentClick();
    }
  };
  return ___EmotionJSX("div", {
    css: styles.privateInspections
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, provider ? 'Request an inspection time' : 'Send an enquiry'), ___EmotionJSX("p", {
    css: styles.body
  }, provider ? "Let ".concat(agentName, " know an inspection time that works for you.") : "Contact ".concat(agentName, " to learn more about this property, request an inspection or take an online tour.")), ___EmotionJSX(BookButton, {
    css: styles.button,
    appearance: "primary",
    size: "standard",
    onClick: handleBookInspection,
    href: url,
    target: url && '_blank'
  }, provider ? 'Book inspection' : 'Contact agent'));
};
PrivateInspections.propTypes = {
  bookInspection: PropTypes.shape({
    url: PropTypes.string,
    provider: PropTypes.string
  }),
  agentName: PropTypes.string,
  onBookHomepassInspectionClick: PropTypes.func,
  onContactAgentClick: PropTypes.func
};
PrivateInspections.defaultProps = {
  bookInspection: {},
  agentName: 'the agent',
  onBookHomepassInspectionClick: () => {},
  onContactAgentClick: () => {}
};
export default withEventBoundary('private-inspections')(PrivateInspections);